import ItemVatDeterminer from "@/module/Form/VatDeterminer/ItemVatDeterminer";
import FormItem from "@/module/FormItem";
import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";
import ForeignVatProvider from "@/module/Form/ForeignVatProvider/ForeignVatProvider";
import { ItemType } from "@/module/Item/ItemType";
import {
  ForeignVatType,
  itemTypeToForeignVatType,
} from "@/module/Form/ForeignVatProvider/ForeignVatType";
import { OssType } from "@/module/Form/Oss/OssType";

export default class IdentifiedPersonItemVatStrategy
  implements ItemVatDeterminer
{
  private readonly ossMode: number;
  private readonly foreignCustomerDeterminer: ForeignCustomerDeterminer;
  private readonly foreignVatProvider: ForeignVatProvider;

  constructor(
    ossMode: number,
    foreignCustomerDeterminer: ForeignCustomerDeterminer,
    foreignVatProvider: ForeignVatProvider,
  ) {
    this.ossMode = Number(ossMode);
    this.foreignCustomerDeterminer = foreignCustomerDeterminer;
    this.foreignVatProvider = foreignVatProvider;
  }

  determinateItemVat(
    item: FormItem,
    country: string | null,
    isReverseCharge: boolean,
    isTaxExempt: boolean,
    isCompany: boolean,
  ): number {
    if (isTaxExempt || isReverseCharge) {
      return 0.0;
    }

    if (!this.foreignCustomerDeterminer.isForeignCustomer(country)) {
      return 0.0;
    }

    if (this.ossMode === OssType.NATIVE_VAT) {
      return 0.0;
    }

    if (
      !(
        item.isOneStopShopItemType &&
        this.foreignCustomerDeterminer.isForeignCustomer(country) &&
        this.foreignCustomerDeterminer.isCountryInEu(country)
      )
    ) {
      return item.originVat;
    }

    if (!isCompany || this.ossMode === OssType.OSS_VAT) {
      let vatRate = this.foreignVatProvider.findVat(
        String(country),
        itemTypeToForeignVatType(item.type as ItemType),
      );

      if (vatRate !== null) {
        return vatRate;
      }

      vatRate = this.foreignVatProvider.findVat(
        String(country),
        ForeignVatType.ELECTRONIC_SERVICE,
      );

      if (vatRate !== null) {
        return vatRate;
      }

      return item.originVat;
    }

    return item.originVat;
  }
}
